import PrismicDOM from 'prismic-dom'
import Dayjs from 'dayjs'

export function processDate(el) {
	return Dayjs(PrismicDOM.Date(el)).format('MMMM D')
}

export function getHtml(el) {
	return PrismicDOM.RichText.asHtml(el)
}

export function getText(el) {
	return PrismicDOM.RichText.asText(el)
}

export function mapLink(el) {
	return `https://www.google.com/maps/search/?api=1&query=${el.latitude},${el.longitude}`
}

export function mapSearchLink(el) {
	return `https://www.google.com/maps/search/${el}`
}